import React, { Dispatch, SetStateAction } from 'react';
import { Pagination } from 'react-bootstrap';

import './Paginator.scss';
import styles from './Paginator.module.scss';

interface Props {
  page: number;
  maxPages: number;

  setPage: Dispatch<SetStateAction<number>>;
}

const Paginator = ({ page, maxPages, setPage }: Props) => {
  const minPage = Math.max(1, page - 2);
  const maxPage = Math.min(maxPages, minPage + 4);

  const paginationItems = [];

  for (let i = minPage; i <= maxPage; i += 1) {
    paginationItems.push(
      <Pagination.Item key={i} active={i === page} onClick={() => setPage(i)}>
        {i}
      </Pagination.Item>,
    );
  }

  return (
    <div className={styles.paginator_container}>
      <Pagination>
        <Pagination.First onClick={() => setPage(1)} />
        {paginationItems}
        <Pagination.Last onClick={() => setPage(maxPages)} />
      </Pagination>
    </div>
  );
};

export default Paginator;
